import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import React from 'react';
import CheckSquareOutlineSvg from '../../assets/img/check-square-outline.svg';
import CheckSquareUnselectedSvg from '../../assets/img/check-square-unselected.svg';

type ICustomCheckboxProps = {
  onClick: (_event: React.MouseEvent<HTMLButtonElement>) => void;
  checked: boolean;
};

function CustomCheckbox({ onClick, checked }: ICustomCheckboxProps) {
  return (
    <Checkbox
      inputProps={{ 'aria-label': 'controlled' }}
      onClick={onClick}
      checked={checked}
      checkedIcon={<Box component="img" src={CheckSquareOutlineSvg} />}
      icon={<Box component="img" src={CheckSquareUnselectedSvg} />}
      edge="start"
    />
  );
}

export default CustomCheckbox;
